export default {"src":"/_next/static/media/pulse_logo_rgb_electric-lavender.2dea4e77.svg","height":66,"width":275,"blurWidth":0,"blurHeight":0};